import * as Sentry from "@sentry/react";
import { scrubSentryEvent } from "./observability/sentry";

// The staging site is a preview deployment of the same Vercel project as
// production, so both are built with mode "production" and MODE alone cannot
// tell them apart (staging errors were tagged environment:production — see
// Sentry issue 7590833166). The hostname is the only signal that survives
// the shared build.
export function resolveSentryEnvironment(): string {
  if (
    typeof window !== "undefined" &&
    window.location.hostname.includes("staging")
  ) {
    return "STAGING";
  }
  return import.meta.env.MODE;
}

export function initSentry() {
  const dsn = import.meta.env.SENTRY_DSN;

  if (!dsn) {
    if (import.meta.env.DEV) {
      console.warn("Sentry DSN not configured");
    }
    return;
  }

  Sentry.init({
    dsn,
    environment: resolveSentryEnvironment(),
    release: import.meta.env.SENTRY_RELEASE || undefined,

    integrations: [Sentry.browserTracingIntegration()],

    tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
    enabled: true,

    initialScope: {
      tags: {
        app: "homehelpy-main-frontend",
      },
    },
    ignoreErrors: [
      /INTERNAL ASSERTION FAILED: Pending promise was never set/,
      /window\.webkit\.messageHandlers/,
      /Non-Error promise rejection captured with value: Object Not Found Matching Id/,
      /auth\/user-cancelled/,
      /Connection to Indexed Database server lost/,
      /uncaught exception: undefined/, // browser extension / cross-origin noise — Sentry ID afd1e410
      /Failed to register a ServiceWorker/, // ad blockers / in-app browsers / privacy modes — Sentry HOMEHELPYWEBSITEFRONTEND-RC/RD
      /Converting circular structure to JSON/, // extensions patching appendChild to serialize DOM nodes — KAN-547
    ],
    beforeSend: (event) => scrubSentryEvent(event),
  });
}
